import { createRESTStore } from "@stores/shared/createRESTStore";
import API from "@config/shared/api-paths";
import apiClient from "@services/api/apiClient";

const useFavouritesUserCollectionStore = createRESTStore({
  entityName: "favouritesUserCollections",
  apiPaths: {
    fetch: API.BASE + API.FRONTEND.USER_FAVOURITE_COLLECTION + "/list",
    create: API.BASE + API.FRONTEND.FAVOURITE_COLLECTION,
  },
  initialState: [],
  processResponse: {
    fetch: (response) => response.items,
  },

  additionalActions: (set, get) => ({
    createUserCollection: async (data, successCallback, errorCallback) => {
      try {
        set({ creating: true });
        const result = await apiClient(get().apiPaths.create, {
          method: "POST",
          body: JSON.stringify(data),
        });

        set((state) => ({
          ...state,
          favouritesUserCollections: [
            ...state.favouritesUserCollections,
            {
              ...result.data,
            },
          ],
          creating: false,
        }));

        successCallback();
      } catch (error) {
        errorCallback(error);
        set({ creating: false });
      }
    },
  }),
});

export default useFavouritesUserCollectionStore;
